import { render, staticRenderFns } from "./FCheckboxGroup.vue?vue&type=template&id=27768bff&"
import script from "./FCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./FCheckboxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports